import { render } from "./EditPRSummary.vue?vue&type=template&id=79b0172a"
import script from "./EditPRSummary.vue?vue&type=script&lang=js"
export * from "./EditPRSummary.vue?vue&type=script&lang=js"

import "./EditPRSummary.vue?vue&type=style&index=0&id=79b0172a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__